import React from 'react';
import {connect} from 'react-redux';
import UberEatsGameResultWidget from './Widgets/GameResult';
import UberEatsPlayersPerDayWidget from './Widgets/PlayersPerDay';
import UberEatsPlayersPerWeekWidget from './Widgets/PlayersPerWeek';
import UberEatsBackupWinnersWidget from './Widgets/BackupWinners';

const UberEatsStats = props => (
  <div id="ue-stats">
    <header className="content-header">
      <h1>
        Statistics
        <small> GOAT Uber Eats</small>
      </h1>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-6">
          <UberEatsGameResultWidget />
          <UberEatsBackupWinnersWidget />
        </div>
        <div className="col-md-6">
          <UberEatsPlayersPerDayWidget />
          <UberEatsPlayersPerWeekWidget />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UberEatsStats);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Stats/index.tsx